(() => {
  const elementName = 'cws-home-product-action';

  if (!window.customElements || window.customElements.get(elementName)) return;

  class CwsHomeProductAction extends HTMLElement {
    connectedCallback() {
      if (this.isInitialized) return;

      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[data-cws-home-product-submit]');
      this.defaultLabel = this.querySelector('[data-cws-home-product-label]');
      this.stateLabel = this.querySelector('[data-cws-home-product-state]');
      this.status = this.querySelector('[data-cws-home-product-status]');

      if (!this.form || !this.submitButton || !this.defaultLabel || !this.stateLabel || !this.status) return;

      this.isInitialized = true;
      this.isSubmitting = false;
      this.resetTimer = null;
      this.handleSubmit = this.handleSubmit.bind(this);
      this.form.addEventListener('submit', this.handleSubmit);
    }

    disconnectedCallback() {
      if (!this.isInitialized) return;

      this.form.removeEventListener('submit', this.handleSubmit);
      window.clearTimeout(this.resetTimer);
      this.isInitialized = false;
    }

    getRuntime() {
      if (typeof window.fetch !== 'function' || typeof window.FormData !== 'function') return null;
      if (!window.Alpine || typeof window.Alpine.store !== 'function') return null;
      if (typeof getSectionInnerHTML !== 'function') return null;

      try {
        const cartHelper = window.Alpine.store('xCartHelper');
        const miniCart = window.Alpine.store('xMiniCart');

        if (!cartHelper || typeof cartHelper.getSectionsToRender !== 'function') return null;
        if (!miniCart || typeof miniCart.openCart !== 'function') return null;

        return { cartHelper, miniCart };
      } catch {
        return null;
      }
    }

    async handleSubmit(event) {
      if (event.defaultPrevented) return;

      if (this.isSubmitting) {
        event.preventDefault();
        return;
      }

      const runtime = this.getRuntime();
      if (!runtime) return;

      event.preventDefault();
      this.setSubmitting(true);
      this.setState(this.dataset.loadingMessage);

      let sectionsToRender = [];

      try {
        if (typeof runtime.cartHelper.waitForEstimateUpdate === 'function') {
          await runtime.cartHelper.waitForEstimateUpdate();
        }
        window.updatingEstimate = true;

        sectionsToRender = runtime.cartHelper.getSectionsToRender();
        const sectionIds = [...new Set(
          sectionsToRender
            .map((section) => section.id)
            .filter(Boolean)
        )];
        const formData = new FormData(this.form);

        formData.set('sections', sectionIds.join(','));
        formData.set('sections_url', window.location.pathname);

        const fetchResponse = await fetch(this.form.action, {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData,
          credentials: 'same-origin'
        });
        const response = await fetchResponse.json();

        if (!fetchResponse.ok || Number(response.status) === 422) {
          const errorMessage = response.description || response.message || this.dataset.errorMessage;

          console.error('[CWS home cart] Add to cart failed.', {
            payload: response,
            status: fetchResponse.status,
          });
          this.setState(errorMessage, 5000);
          return;
        }

        sectionsToRender.forEach((section) => {
          const sectionElement = document.querySelector(section.selector);
          const sectionHtml = response.sections && response.sections[section.id];

          if (!sectionElement || !sectionHtml) return;
          sectionElement.innerHTML = getSectionInnerHTML(sectionHtml, section.selector);
        });

        const cartCount = document.querySelector('#cart-icon-bubble span');
        const itemCount = cartCount ? Number.parseInt(cartCount.textContent, 10) : Number.NaN;

        if (Number.isFinite(itemCount)) {
          runtime.cartHelper.currentItemCount = itemCount;
        }

        this.setState(this.dataset.successMessage, 2500);
        runtime.miniCart.openCart();
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
        document.dispatchEvent(new CustomEvent('eurus:cart:redirect'));
      } catch (error) {
        console.error('[CWS home cart] Add to cart request failed.', error);
        this.setState(this.dataset.errorMessage, 5000);
      } finally {
        if (typeof runtime.cartHelper.updateEstimateShippingFull === 'function') {
          runtime.cartHelper.updateEstimateShippingFull();
        }

        window.updatingEstimate = false;
        this.setSubmitting(false);
      }
    }

    setSubmitting(isSubmitting) {
      this.isSubmitting = isSubmitting;
      this.form.setAttribute('aria-busy', String(isSubmitting));
      this.submitButton.setAttribute('aria-busy', String(isSubmitting));
      this.submitButton.disabled = isSubmitting;
    }

    setState(message, resetDelay) {
      const stateMessage = message || this.dataset.errorMessage;

      window.clearTimeout(this.resetTimer);
      this.defaultLabel.hidden = true;
      this.stateLabel.hidden = false;
      this.stateLabel.textContent = stateMessage;
      this.status.textContent = '';

      window.requestAnimationFrame(() => {
        this.status.textContent = stateMessage;
      });

      if (!resetDelay) return;

      this.resetTimer = window.setTimeout(() => {
        this.defaultLabel.hidden = false;
        this.stateLabel.hidden = true;
        this.stateLabel.textContent = '';
        this.status.textContent = '';
      }, resetDelay);
    }
  }

  window.customElements.define(elementName, CwsHomeProductAction);
})();
